/**
 * @generated SignedSource<<111ae790192c3ea52ab8329916aa7abd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminAppQuery$variables = Record<PropertyKey, never>;
export type AdminAppQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AdminApp_query">;
};
export type AdminAppQuery = {
  response: AdminAppQuery$data;
  variables: AdminAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameFriendly",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "logo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "fitIn",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "url",
      "storageKey": "url(fitIn:true)"
    },
    (v0/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminAppQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AdminApp_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AdminAppQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "features",
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectType",
                "storageKey": null
              },
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyCorePreferences",
                    "kind": "LinkedField",
                    "name": "core",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompanyAgreementTermPreferences",
                        "kind": "LinkedField",
                        "name": "agreementTerm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyComplaintPreferences",
                    "kind": "LinkedField",
                    "name": "complaint",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ComplaintModulePreferences",
                        "kind": "LinkedField",
                        "name": "module",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hideMenu",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyPreferencesFeedback",
                    "kind": "LinkedField",
                    "name": "feedback",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeedbackModulePreferences",
                        "kind": "LinkedField",
                        "name": "module",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "pluralName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "allowFeedbackRequest",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "allowSelfReview",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyComplaintExternalPreferences",
                    "kind": "LinkedField",
                    "name": "complaintExternal",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ComplaintExternalModulePreferences",
                        "kind": "LinkedField",
                        "name": "module",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "trialDate",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allRoles",
            "storageKey": null
          },
          (v0/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shouldChangePassword",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAcceptAgreementTerm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "profileImage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pendingFeedbackRequestCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pendingFeedbackRequestSentCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pendingUserManagerInvitationsCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pendingUserManagerTransfersCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "feedbacksReceivedCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasGoalGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isResponsibleByCostRevenueCenters",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isResponsibleForSomeCase",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isInNineBox",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNineBoxReportAvailable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasDataExports",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "BusinessDivisionConnection",
            "kind": "LinkedField",
            "name": "businessDivisions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BusinessDivisionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BusinessDivision",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "businessDivisions(first:1)"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3
              }
            ],
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "myTeam",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfoExtended",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nick",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "myTeam(first:3)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v1/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "49c405d5eae88440571135ae79be132f",
    "id": null,
    "metadata": {},
    "name": "AdminAppQuery",
    "operationKind": "query",
    "text": "query AdminAppQuery {\n  ...AdminApp_query\n}\n\nfragment AdminApp_query on Query {\n  me {\n    company {\n      features\n      id\n      projectType\n      _id\n      name\n      preferences {\n        core {\n          agreementTerm {\n            active\n          }\n        }\n      }\n    }\n    isAdmin\n    allRoles\n    ...useCrisp_user\n    ...usePermissionFragment\n    _id\n    id\n    name\n    shouldChangePassword\n    hasAcceptAgreementTerm\n  }\n  company: companyDomainName {\n    id\n    _id\n    name\n    nameFriendly\n    logo {\n      url(fitIn: true)\n      id\n    }\n  }\n  ...Header_query\n  ...Sidebar_query\n}\n\nfragment Brand_company on Company {\n  id\n  nameFriendly\n  logo {\n    url(fitIn: true)\n    id\n  }\n}\n\nfragment FeatureFlag_user on User {\n  ...usePermissionFragment\n}\n\nfragment FeatureTemp_user on User {\n  ...FeatureFlag_user\n}\n\nfragment HeaderTrialWarning_me on User {\n  company {\n    trialDate\n    projectType\n    id\n  }\n}\n\nfragment Header_query on Query {\n  me {\n    ...HeaderTrialWarning_me\n    ...User_me\n    ...Support_user\n    id\n  }\n}\n\nfragment SidebarHeader_me on User {\n  company {\n    projectType\n    ...Brand_company\n    id\n  }\n  ...FeatureTemp_user\n}\n\nfragment Sidebar_query on Query {\n  ...menuItems_query\n  me {\n    isAdmin\n    allRoles\n    company {\n      features\n      projectType\n      id\n      nameFriendly\n      ...Brand_company\n      preferences {\n        complaint {\n          module {\n            name\n          }\n          hideMenu\n        }\n        feedback {\n          module {\n            name\n            pluralName\n          }\n          allowFeedbackRequest\n          allowSelfReview\n        }\n        complaintExternal {\n          module {\n            name\n          }\n        }\n      }\n    }\n    ...SidebarHeader_me\n    id\n    name\n    hasGoalGroup\n    isResponsibleByCostRevenueCenters\n    isResponsibleForSomeCase\n    isInNineBox\n    hasNineBoxReportAvailable\n    hasDataExports\n    businessDivisions(first: 1) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    myTeam(first: 3) {\n      pageInfo {\n        hasNextPage\n      }\n      edges {\n        node {\n          id\n          name\n          nick\n        }\n      }\n    }\n  }\n  version\n}\n\nfragment Support_user on User {\n  ...FeatureFlag_user\n}\n\nfragment User_me on User {\n  profileImage {\n    url\n    id\n  }\n}\n\nfragment menuItems_query on Query {\n  me {\n    id\n    ...usePermissionFragment\n    isAdmin\n    allRoles\n    company {\n      features\n      projectType\n      id\n      nameFriendly\n      preferences {\n        complaint {\n          module {\n            name\n          }\n          hideMenu\n        }\n        feedback {\n          module {\n            name\n            pluralName\n          }\n          allowFeedbackRequest\n          allowSelfReview\n        }\n        complaintExternal {\n          module {\n            name\n          }\n        }\n      }\n    }\n    pendingFeedbackRequestCount\n    pendingFeedbackRequestSentCount\n    pendingUserManagerInvitationsCount\n    pendingUserManagerTransfersCount\n    feedbacksReceivedCount\n    hasGoalGroup\n    isResponsibleByCostRevenueCenters\n    isResponsibleForSomeCase\n    isInNineBox\n    hasNineBoxReportAvailable\n    hasDataExports\n    businessDivisions(first: 1) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    myTeam(first: 3) {\n      pageInfo {\n        hasNextPage\n      }\n      edges {\n        node {\n          id\n          name\n          nick\n        }\n      }\n    }\n  }\n}\n\nfragment useCrisp_user on User {\n  id\n  name\n  email\n  company {\n    nameFriendly\n    id\n  }\n}\n\nfragment usePermissionFragment on User {\n  isAdmin\n  allRoles\n  company {\n    features\n    projectType\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1cbdc3c57a941f19ca4db836b107b8ca";

export default node;
